import * as React from 'react'

import { Box, Icon } from '@factorialco/deprecated-design-system'
import { type SelectOption } from '@factorialco/deprecated-design-system'
import values from 'lodash/values'

import i18n from 'modules/core/lib/i18n'

import Label from 'modules/reports/components/Editor/Carcasa/FormFields/FieldSelector/Label'
import { useLoadingFields } from 'modules/reports/contexts/loadFieldsContext'
import useFields from 'modules/reports/hooks/useFields'
import { useReportTracking } from 'modules/reports/hooks/useReportTracking'
import type { ReportEditorStore } from 'modules/reports/lib/Store'
import { events } from 'modules/reports/lib/events'
import Report from 'modules/reports/store/models/Report'

import Option from './Option'

interface Props {
  store: ReportEditorStore
}

const SelectChartSelector = ({ store }: Props) => {
  const { track } = useReportTracking(store)
  const [, setLoadingFields] = useLoadingFields()
  const loadFields = useFields()
  const [toggle, setToggle] = React.useState<boolean>(false)
  const changeToggle = () => {
    setToggle(!toggle)
  }

  const chartType = store.reportForm.get('chart_type')
  const savedReportType = store.report.get('chart_type')

  let chartTypes = values(Report.CHART_TYPES)
  chartTypes =
    savedReportType === 'scatterplot' ? chartTypes : chartTypes.filter((v) => v !== 'scatterplot')

  const options: SelectOption[] = chartTypes.map((value) => ({
    value,
    label: value,
  }))

  let selectedOption = options.find((option) => option.value == chartType.value)
  const defaultOption = options.find((option) => option.value === 'bars')

  if (!chartType.value) {
    chartType.set('bars')
  }

  selectedOption = !selectedOption ? defaultOption! : selectedOption

  const changeChartType = (value: string) => {
    track(events.chartTypeSelected, {
      new_chart_type: value,
    })
    const previousFieldValue = chartType.value
    chartType.set(value)
    store.resetForms(previousFieldValue)
    changeToggle()
    loadFields(
      { projections: store.projection.paths() },
      (status) => setLoadingFields(status),
      (status) => setLoadingFields(status)
    )
  }

  return (
    <>
      <Label text={i18n.t('custom_reports.fields.type')} />
      <Box
        paddingBottom="s32"
        width="full"
        onClick={changeToggle}
        onMouseLeave={() => {
          setToggle(false)
        }}
      >
        <Box
          flexDirection="row"
          padding="s8"
          borderRadius={{ all: 'abs008' }}
          border={{
            all: {
              width: 's2',
              style: 'solid',
              color: 'grey400',
            },
          }}
        >
          <Option
            defaultSelector
            style={{ paddingBottom: 's0', paddingTop: 's0' }}
            option={selectedOption}
          />
          <Box style={{ position: 'relative', marginTop: '2%' }}>
            <Icon.Small icon="caret-down" />
          </Box>
        </Box>
        {toggle && (
          <Box onMouseLeave={changeToggle} style={{ position: 'relative' }}>
            <Box
              style={{ position: 'absolute', zIndex: '1', left: '0', right: '0' }}
              padding="s8"
              background="grey000White"
              borderRadius={{ all: 'abs008' }}
              boxShadow="s100"
            >
              {options.map((option) => (
                <Option onSelect={changeChartType} key={option.value} option={option} />
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </>
  )
}

export default SelectChartSelector
